export const firebaseConfig = {
    apiKey: "AIzaSyCi1tZQKN5TysHXiSh77guT82u2A5g_0Og",
    authDomain: "chermo-bb9db.firebaseapp.com",
    projectId: "chermo-bb9db",
    storageBucket: "chermo-bb9db.appspot.com",
    messagingSenderId: "916200354142",
    appId: "1:916200354142:web:01235038a0d2cf4ee21fcf",
    measurementId: "G-XZPR0E6LYS"
};